import React, { useState, useEffect } from 'react';
import { 
    Dialog, 
    DialogContent, 
    DialogActions, 
    TextField, 
    Button, 
    Box, 
    IconButton, 
    InputAdornment 
} from '@mui/material';
import { toast } from 'react-toastify';
import { editStops, editSTMSStops } from './action.ts'; 
import MapModal from '../Warehouses/map-modal.tsx'; 
import Heading from '../../Components/Heading/heading.tsx';
import mapsIcon from '../../../assets/map.png';

interface EditStopsModalProps {
    open: boolean;
    onClose: () => void;
    stop: any;
    onSuccess?: () => void;
}

const EditStopsModal: React.FC<EditStopsModalProps> = ({ open, onClose, stop, onSuccess }) => {
    const [name, setName] = useState('');
    const [companiesId, setCompaniesId] = useState('');
    const [lat, setLat] = useState('');
    const [lng, setLng] = useState('');
    const [address, setAddress] = useState('');
    const [addressError, setAddressError] = useState('');

    const [isMapOpen, setIsMapOpen] = useState(false);

    useEffect(() => {
        if (stop) {
            setName(stop.stopName || stop.name || ''); 
            setCompaniesId(String(stop.company_id || stop.companyId || ''));
            setLat(stop.lat || stop.latitude || '');
            setLng(stop.lng || stop.longitude || '');
            setAddress(stop.address || '');
        }
    }, [stop]);

    const handleLocationSelect = (selectedAddress: string, selectedLat: string, selectedLng: string) => {
        setLat(selectedLat);
        setLng(selectedLng);
    };

    const handleAddressChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setAddress(value);
        if (/[%*(){}\[\]]/.test(value)) {
            setAddressError('Characters % * ( ) { } [ ] are not allowed');
        } else {
            setAddressError('');
        }
    };

    const handleClose = () => {
        setAddressError('');
        onClose();
    };

    const handleSubmit = () => {
        if (addressError) {
            return;
        }

        const handleSuccess = (response: any) => {
            if (response.status === 200 || response.status === 201) {
                toast.success("Stop updated successfully");
                handleClose();
                if (onSuccess) {
                    onSuccess();
                }
            } else {
                toast.error(response.message || "Failed to update stop");
            }
        };

        const handleError = (errorMessage: string) => {
            toast.error(errorMessage);
        };

        if (companiesId === '95' || companiesId === '11') {
            console.log(stop?.vehicleId, stop);
            editSTMSStops(
                stop?.id,
                handleSuccess,
                handleError,
                name,
                address,
                stop?.status,
                lat,
                lng,
                200,
                companiesId,
                stop?.vehicleId,
            );
        } else {
            console.log(address)
            editStops(
                stop?.id,
                handleSuccess,
                handleError,
                name,
                address,
                lat,
                lng,
                200,
                companiesId,
                stop?.vehicleId,
            );
        }
    };

    const initialLocation = lat && lng 
        ? { lat: parseFloat(lat), lng: parseFloat(lng) } 
        : undefined;

    return (
        <>
            <Dialog open={open} onClose={handleClose} maxWidth="sm" >
                <Box
                    sx={{
                        marginLeft: {
                            xs: '0px',
                            sm: '-180px',
                        }
                    }}
                >    
                    <Heading title="Edit Stop" closeIcon="true" onClose={handleClose} />
                </Box>
                <DialogContent>
                    <Box display="flex" flexDirection="column" gap={2} mt={1}>
                        <TextField 
                            label="Stop Name" 
                            value={name} 
                            onChange={(e) => setName(e.target.value)} 
                            sx={{ width: '210px' }}
                            size="small" 
                        />
                        
                        {/* New Address Multiline Field */}
                        <TextField 
                            label="Address" 
                            multiline
                            rows={3}
                            value={address} 
                            onChange={handleAddressChange} 
                            error={!!addressError}
                            helperText={addressError}
                            sx={{ width: '210px' }}
                            size="small" 
                        />

                        <TextField 
                            label="Latitude" 
                            value={lat} 
                            onChange={(e) => setLat(e.target.value)}
                            placeholder="Auto-filled from map"
                            sx={{ width: '210px' }}
                            size="small" 
                        />
                        
                        <TextField 
                            label="Longitude" 
                            value={lng} 
                            onChange={(e) => setLng(e.target.value)}
                            placeholder="Auto-filled from map"
                            sx={{ width: '210px' }}
                            size="small" 
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton 
                                            onClick={() => setIsMapOpen(true)} 
                                            color="primary"
                                            edge="end"
                                            title="Select location on map"
                                        >
                                            <img src={mapsIcon} alt="Map View" style={{ width: '30px', height: '30px' }} />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }} 
                        />
                    </Box>
                </DialogContent>
                <DialogActions style={{ justifyContent: 'center' }}>
                    <Button onClick={handleClose} className="custom-cancel-button">Cancel</Button>
                    <Button onClick={handleSubmit} className="custom-button" variant="contained">Save</Button>
                </DialogActions>
            </Dialog>

            <MapModal 
                open={isMapOpen} 
                onClose={() => setIsMapOpen(false)} 
                onLocationSelect={handleLocationSelect}
                initialLocation={initialLocation}
            />
        </>
    );
};

export default EditStopsModal;